import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { Bell, CheckCircle2, Loader2, XCircle, ArrowLeft } from "lucide-react";
import { API_BASE } from "@/lib/supabase";

export default function WaitlistUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, ok: false, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await axios.get(`${API_BASE}/waitlist/unsubscribe/${encodeURIComponent(token)}`);
        if (!cancelled) setState({ loading: false, ok: true, error: null });
      } catch (e) {
        if (!cancelled)
          setState({
            loading: false,
            ok: false,
            error: e?.response?.data?.detail || e.message || "Ongeldige of verlopen link",
          });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div
      data-testid="waitlist-unsubscribe-page"
      className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-16"
    >
      <div className="w-full max-w-md bg-svj-card border border-svj-border rounded-2xl p-8 text-center">
        <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-svj-cyan/10 border border-svj-cyan/30">
          <Bell className="h-6 w-6 text-svj-cyan" />
        </div>
        <h1 className="mt-5 text-2xl font-extrabold text-white">Wachtlijst uitschrijving</h1>

        {state.loading && (
          <div className="mt-6 text-slate-400">
            <Loader2 className="h-5 w-5 mx-auto animate-spin text-svj-cyan" />
            <div className="mt-3 text-sm">Bezig met uitschrijven…</div>
          </div>
        )}

        {!state.loading && state.ok && (
          <div data-testid="waitlist-unsubscribed" className="mt-6">
            <div className="inline-flex items-center gap-2 text-emerald-300">
              <CheckCircle2 className="h-5 w-5" />
              <span className="font-semibold">Je bent uitgeschreven</span>
            </div>
            <p className="mt-3 text-sm text-slate-400">
              Je krijgt geen wachtlijst-mails meer voor dit event. Alsnog een ticket bemachtigen?
            </p>
            <Link
              to="/events"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-svj-orange via-svj-pink to-svj-purple text-white font-bold py-2.5 px-5 hover:shadow-[0_0_24px_rgba(214,61,122,0.5)]"
            >
              <ArrowLeft className="h-4 w-4" /> Bekijk andere events
            </Link>
          </div>
        )}

        {!state.loading && !state.ok && (
          <div data-testid="waitlist-unsubscribe-error" className="mt-6">
            <div className="inline-flex items-center gap-2 text-red-300">
              <XCircle className="h-5 w-5" />
              <span className="font-semibold">Ongeldige of verlopen link</span>
            </div>
            <p className="mt-3 text-sm text-slate-400">{state.error}</p>
          </div>
        )}
      </div>
    </div>
  );
}
